import FollowCard from '../follow_card/follow_card.vue'

const People = {
  name: 'People',

  components: {
    FollowCard
  },

  data () {
    return {
      activeTab: 'following',
      following: [],
      followers: [],
      search: '',
      loadingFollowing: false,
      loadingFollowers: false,
      followingLoaded: false,
      followersLoaded: false,
      error: ''
    }
  },

  computed: {
    currentUser () {
      return this.$store.state.users.currentUser
    },

    activeUsers () {
      const source = this.activeTab === 'following'
        ? this.following
        : this.followers

      const q = this.search.trim().toLowerCase()

      const users = !q
        ? source
        : source.filter(user => {
          const values = [
            user.name,
            user.screen_name,
            user.screen_name_ui,
            user.nickname,
            user.acct
          ]
            .filter(Boolean)
            .map(value => String(value).toLowerCase())

          return values.some(value => value.includes(q))
        })

      return [...users].sort((a, b) => {
        const aName = a.name || a.screen_name || a.nickname || ''
        const bName = b.name || b.screen_name || b.nickname || ''

        return aName.localeCompare(bName)
      })
    },

    loading () {
      return this.activeTab === 'following'
        ? this.loadingFollowing
        : this.loadingFollowers
    },

    activeCount () {
      return this.activeTab === 'following'
        ? this.following.length
        : this.followers.length
    }
  },

  created () {
    this.loadFollowing()
  },

  methods: {
    setTab (tab) {
      this.activeTab = tab
      this.search = ''

      if (tab === 'following' && !this.followingLoaded) {
        this.loadFollowing()
      }

      if (tab === 'followers' && !this.followersLoaded) {
        this.loadFollowers()
      }
    },

    async loadFollowing () {
      if (!this.currentUser || this.loadingFollowing) return

      this.loadingFollowing = true
      this.error = ''

      try {
        const users = await this.$store.state.api.backendInteractor.fetchFriends({
          id: this.currentUser.id,
          limit: 80
        })

        this.following = users || []

        if (this.following.length) {
          this.$store.commit('addNewUsers', this.following)
        }

        this.followingLoaded = true
      } catch (e) {
        console.error('People: failed to load following', e)
        this.error = 'Unable to load Following right now.'
      } finally {
        this.loadingFollowing = false
      }
    },

    async loadFollowers () {
      if (!this.currentUser || this.loadingFollowers) return

      this.loadingFollowers = true
      this.error = ''

      try {
        const users = await this.$store.state.api.backendInteractor.fetchFollowers({
          id: this.currentUser.id,
          limit: 80
        })

        this.followers = users || []

        if (this.followers.length) {
          this.$store.commit('addNewUsers', this.followers)
        }

        this.followersLoaded = true
      } catch (e) {
        console.error('People: failed to load followers', e)
        this.error = 'Unable to load Followers right now.'
      } finally {
        this.loadingFollowers = false
      }
    },

    refresh () {
      if (this.activeTab === 'following') {
        this.followingLoaded = false
        this.loadFollowing()
      } else {
        this.followersLoaded = false
        this.loadFollowers()
      }
    }
  }
}

export default People
